export default "__VITE_ASSET__0ec96971__"